/* eslint-disable no-undef */
import { call, put, takeEvery, takeLatest } from "redux-saga/effects"

// Login Redux States
import { GET_SHOPPING_AREAS, GET_SHOPPING_AREAS_V2 } from "./actionTypes"
import { apiError, getShoppingAreasSuccess, getShoppingAreasV2Success, getShoppingAreasV2Error } from "./actions"

//Include Both Helper File with needed methods
import { getShoppingAreas, getShoppingAreasNewApi } from "../../../helpers/backend_helper"

function* shoppingAreas() {
  try {
    const response = yield call(getShoppingAreas)
    yield put(getShoppingAreasSuccess(response))
  } catch (error) {
    yield put(apiError(error))
  }
}

function* shoppingAreasV2() {
  try {
    const response = yield call(getShoppingAreasNewApi)
    yield put(getShoppingAreasV2Success(response))
  } catch (error) {
    yield put(getShoppingAreasV2Error(error))
  }
}

function* shoppingAreasListSaga() {
  yield takeEvery(GET_SHOPPING_AREAS, shoppingAreas)
  yield takeEvery(GET_SHOPPING_AREAS_V2, shoppingAreasV2)
}

export default shoppingAreasListSaga
